import { render, staticRenderFns } from "./ApproveEditProject.vue?vue&type=template&id=b35e5340&scoped=true"
import script from "./ApproveEditProject.vue?vue&type=script&lang=js"
export * from "./ApproveEditProject.vue?vue&type=script&lang=js"
import style0 from "./ApproveEditProject.vue?vue&type=style&index=0&id=b35e5340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35e5340",
  null
  
)

export default component.exports